import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import QuickEnquiry from "@/components/QuickEnquiry";
import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { CONTACT } from "@/data/site";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-brand-cream">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <QuickEnquiry />
      <a
        href={`tel:${CONTACT.primaryPhone}`}
        data-testid="floating-phone"
        className="fixed bottom-6 left-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-orange text-white shadow-[0_10px_30px_-6px_rgba(240,128,32,0.6)] transition-transform hover:scale-110 animate-pulse"
        aria-label="Call us"
      >
        <Phone size={26} weight="fill" />
      </a>
      <a
        href={`https://wa.me/${CONTACT.whatsapp}?text=Hi%20Cluetrip%2C%20I%27d%20love%20to%20plan%20a%20trip.`}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] transition-transform hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        <WhatsappLogo size={30} weight="fill" />
      </a>
    </div>
  );
}
